/**
 * A tela "Tarefas" (história 4.6) — a fila de trabalho inteira, com os quatro filtros.
 *
 *     /tarefas    as Tarefas que a policy entrega, recortadas por prazo (FR-18, FR-20)
 *
 * Ela é filha de `rotaDaAplicacao`, e por isso herda a guarda de sessão do layout — registrada
 * uma vez lá, ela vale para toda rota interna.
 *
 * **O caminho não é novo: `/tarefas` era placeholder desde a 1.4**, e o que muda aqui é só quem
 * desenha o corpo. Por isso ele entra em `COM_TELA_PROPRIA` no mesmo commit: sem isso, o laço de
 * `telas.ts` continuaria registrando uma segunda rota para o mesmo caminho, e qual das duas o
 * roteador escolheria seria detalhe de ordem de declaração, e não decisão de ninguém.
 *
 * **Ela não passa nada por prop, ao contrário de `hoje.tsx` e `funil.tsx`.** Lá a rota resolve o
 * que é **contexto da tela** — o catálogo de Funis, os dois cortes da régua — e passa adiante. Aqui
 * não há contexto: a lista não desenha Etapa nem cor, e não há régua nesta tela. O que ela
 * consulta — as Tarefas, os nomes de Empresa, a equipe e o catálogo de Tipos — é o **conteúdo**, e
 * conteúdo o componente consulta sozinho.
 *
 * **Sem cabeçalho próprio, e sem `useDefinirTitulo`.** O `<h1>` da página é o do `Cabecalho`, e um
 * segundo título aqui daria dois na mesma tela. Ao contrário de `/originados`, o item "Tarefas"
 * existe no menu de **todos** os perfis, então `itemDoCaminho` sempre o encontra e o título sai de
 * lá — publicá-lo de novo aqui seria escrever o mesmo texto em dois lugares.
 *
 * **O subtítulo, ao contrário, é publicado pela tela** (`useDefinirSubtitulo`, dentro de
 * `<Tarefas>`): ele é o **filtro ativo**, que muda com o clique e que o item de navegação não tem
 * como saber. É o mesmo par que a ficha da Empresa já usa, e é o que o protótipo desenha (`:974`).
 */

import { createRoute } from '@tanstack/react-router'

import { Tarefas } from '@/modulos/negocios/Tarefas'
import { CAMINHOS } from '@/shell/navegacao'
import { rotaDaAplicacao } from './aplicacao'

export const rotaDeTarefas = createRoute({
  getParentRoute: () => rotaDaAplicacao,
  path: CAMINHOS.tarefas,
  component: Tarefas,
})
